import { calPercentChange } from '../../../src/utils/global'
import { convertGoldOzToThaiBaht } from "../../../src/utils/gold"
import * as constant from './constant'

export const mutations = {
    [constant.GOLD_TRADER_PRESENT] (state, payload) {
        if (payload) state.goldTraderPresent = payload
    },
    [constant.GOLD_HISTORY_LIST](state, payload) {
        if (payload) {
            state.goldHistoryList = [...state.goldHistoryList, payload]
        }
    },
    [constant.GOLD_TRADER_HISTORY_GRAPH](state, payload) {
        if (payload) {
            state.goldHistoryGraph = payload
        }
    },
    [constant.GOLD_SPOT_LAST_QUOTE](state, payload) {
        if (payload) {
            state.goldSpotLastQuote = payload
        }
    },
    [constant.GOLD_SPOT_REAL_TIME](state, payload) {
        if (payload && payload.lastTrade) {
            state.goldSpotLastTrade = payload.lastTrade
        }
    },
    [constant.GOLD_SPOT_REAL_TIME_GRAPH](state, payload) {
        if (payload) {
            payload.forEach(element => {
                let firstPrice = state.goldSpotRealtimeGraph.length ? state.goldSpotRealtimeGraph[0].v : element.b
                let percentChange = calPercentChange(firstPrice, element.b)
                state.goldSpotRealtimeGraph.push({ d: element.t, v: element.b, p: percentChange, t: element.t })
            });
        }
    },
    [constant.GOLD_SPOT_AGGREGATE_GRAPH](state, payload) {
        if (payload) {
            payload.forEach(element => {
                let firstPrice = state.goldSpotRealtimeGraph.length ? state.goldSpotRealtimeGraph[0].v : element.c
                let percentChange = calPercentChange(firstPrice, element.c)
                state.goldSpotRealtimeGraph.push({ d: element.t, v: element.c, p: percentChange, t: element.t })
            });
        }
    },
    [constant.GOLD_SPOT_HISTORY_GRAPH](state, payload) {
        if (payload) {
            state.goldSpotHistoryGraph = payload
        }
    },
    [constant.GOLD_SPOT_PREVIOUS_CLOSE](state, payload) {
        if (payload) {
            state.goldSpotPreviousClose = payload
        }
    },
    [constant.GOLD_SPOT_GLOBAL_GRAPH_SETTING](state, payload) {
        if (payload) {
            state.globalConfiguration = payload
        }
    },
    [constant.GOLD_SPOT_THAI_REAL_TIME_GRAPH](state, payload) {
        if (payload) {
            payload.forEach(element => {
                let convertedPricePerUnit = convertGoldOzToThaiBaht(element.b)
                let firstPrice = state.goldSpotThaiRealtimeGraph.length ? state.goldSpotThaiRealtimeGraph[0].v : convertedPricePerUnit
                let percentChange = calPercentChange(firstPrice, convertedPricePerUnit)
                state.goldSpotThaiRealtimeGraph.push({ d: element.t, v: parseFloat(convertedPricePerUnit), p: percentChange, t: element.t })
            });
        }
    },
    [constant.GOLD_TRADER_REAL_TIME_GRAPH](state, payload) {
        if (payload) {
            payload.forEach(element => {
                let firstPrice = state.goldTraderRealtimeGraph.length ? state.goldTraderRealtimeGraph[0].v : element.barSellPrice
                let percentChange = calPercentChange(parseInt(firstPrice), parseInt(element.barSellPrice))
                element = { t: element.timestamp, v: parseInt(element.barSellPrice), c: element.barPriceChange, ct: element.createdTime, p: percentChange, adt: element.createdDateTime, d: element.timestamp}
                state.goldTraderRealtimeGraph.push(element)
            });
        }
    },
    [constant.GOLD_SPOT_THAI_AGGREGATE_GRAPH](state, payload) {
        if (payload) {
            payload.forEach(element => {
                let convertedPricePerUnit = convertGoldOzToThaiBaht(element.c)
                let firstPrice = state.goldSpotThaiRealtimeGraph.length ? state.goldSpotThaiRealtimeGraph[0].v : convertedPricePerUnit
                let percentChange = calPercentChange(firstPrice, convertedPricePerUnit)
                state.goldSpotThaiRealtimeGraph.push({ d: element.t, v: parseFloat(convertedPricePerUnit), p: percentChange, t: element.t })
            });
        }
    },
    [constant.GOLD_SPOT_THAI_REALTIME_CURRENT_PERIOD](state, period) {
        if (period) state.goldSpotThaiRealtimeCurrentPeriod = period
    },
}